import type { IMosaicTocExpanded, ITocActionUpdateSearchText } from "./interface";

/**
 * Updates the free-text ToC search term.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the new search text.
 * @returns The updated ToC state with the new search text.
 */
export const toc_updateSearchText = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateSearchText,
): IMosaicTocExpanded => ({
  ...state,
  searchText: action.searchText,
});
